/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {whoAmI} from '../api'

export const useMutationWhoAmI = createReactQueryMutationHook('whoAmI', whoAmI)
